import Analytics from '@cndinfo/cube-analytics-sdk'
const analytics = {
  getAnalyticsInstance(obj) {
    let params = {}
    try {
      if (obj.$router) {
        params = {
          routerObject: obj.$router
        }
        // eslint-disable-next-line no-undef
      } else if (plus) {
        try {
          // eslint-disable-next-line no-undef
          const uniPluginObject = uni.requireNativePlugin(
            'RangersAppLogUniPluginCN'
          )
          params = {
            uniPluginObject
          }
        } catch (e) {
          console.log()
        }
      }
    } catch (e) {
      console.log()
    }
    const analyticsInstance = new Analytics(params)
    analyticsInstance.start()
    return analyticsInstance
  }
}
export default analytics
